import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiVisa, CompanyContainerModel, CompanyService } from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'blg-select-company-drop-down',
  templateUrl: './select-company-drop-down.component.html',
  styleUrls: ['./select-company-drop-down.component.scss']
})

export class SelectCompanyDropDownComponent implements OnInit, OnDestroy {

  @Input() apiVisa: ApiVisa;
  @Input() company = new FormControl();
  @Input() required: boolean;

  @Output() companyChange = new EventEmitter<FormControl>();
  @Output() companySelected = new EventEmitter<CompanyContainerModel>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<CompanyContainerModel[]> = new ReplaySubject<CompanyContainerModel[]>(1);
  companyList: CompanyContainerModel[] = [];
  selectedCompany: CompanyContainerModel;
  filteredCompany: any = [];

  protected _onDestroy = new Subject<void>();

  constructor(
    private companyService: CompanyService
) {
  }

  ngOnInit() {
    // if (this.company.value) {
    //   this.companyService.getByGuid(this.company.value, this.apiVisa).pipe(
    //     takeUntil(this._onDestroy)
    //   ).subscribe( resolved => {
    //     // this.companyList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_comp.guid.toString());
    //   });
    // }
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCompany();
      });

    this.getCompany();
  }

  getCompany() {
    this.companyService.get(this.apiVisa).subscribe((x: any) => {
      x.data.forEach((data) => {
        this.filteredCompany.push(data);
        this.companyList.push(data);
      });

      // sorting
      const sorted = this.filteredCompany.sort((a, b) => (a.bl_fi_mst_comp.code < b.bl_fi_mst_comp.code ? -1 : 1));

      this.filteredOptions$.next(sorted.slice());
    });
  }

  filterCompany() {
    if (!this.filteredCompany) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.filteredCompany.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the company
    this.filteredOptions$.next(
      this.filteredCompany.filter((option) =>
        (option.bl_fi_mst_comp.code ?
          option.bl_fi_mst_comp.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.bl_fi_mst_comp.name ?
          option.bl_fi_mst_comp.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(companyGuid: string) {
    if (companyGuid) {
      this.company.patchValue(companyGuid);
      this.selectedCompany = this.companyList.find(company => company.bl_fi_mst_comp.guid === companyGuid);
      this.companySelected.emit(this.selectedCompany);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
